module.exports = __webpack_public_path__ + "img/Financial-commitments-and-debt.d0d8db9f.svg";